import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { Card, CardContent, Grid } from '@material-ui/core';
import CardHeader from 'pages/Settings/components/settings/goals/CardHeader';
import Alarms from 'pages/Settings/components/settings/jobs/alarms';
import MonthlyReports from 'pages/Settings/components/settings/jobs/monthly-reports';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { getSettings } from 'redux/ducks/settings';

type StateProps = ReturnType<typeof mapStateToProps>;
type JobsProps = Record<string, never>;
type OwnProps = StateProps & JobsProps;

const useStyles = makeStyles({
  grid: {
    maxWidth: 1600
  },
  root: {
    height: '100%',
    display: 'flex',
    flexFlow: 'column wrap'
  },
  content: {
    flexGrow: 1
  }
});

const JobsInternal: React.FunctionComponent<OwnProps> = ({ monthlyReportTemplateType }) => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <Grid container spacing={3} className={classes.grid}>
      <Grid item xs={12} xl={monthlyReportTemplateType ? 6 : 12}>
        <Card className={classes.root}>
          <CardContent className={classes.content}>
            <CardHeader title={intl.formatMessage({ id: 'alarms' })} />
            <Alarms />
          </CardContent>
        </Card>
      </Grid>
      {monthlyReportTemplateType && (
        <Grid item xs={12} xl={6}>
          <Card className={classes.root}>
            <CardContent className={classes.content}>
              <CardHeader title={intl.formatMessage({ id: 'monthlyReportRecipients.title' })} />
              <MonthlyReports />
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state: RootState) => ({
  monthlyReportTemplateType: getSettings(state).monthlyReportTemplateType
});

export const Jobs = connect<StateProps, unknown, JobsProps>(mapStateToProps)(JobsInternal);
